import React, { useCallback, useEffect, useState } from 'react';

import PassCode from './PassCode';

import { usePatientDocumentContext } from '../../contexts/PatientDocument';
import { usePatientFormContext } from "../../contexts/PatientForm";
import { passCodeMessageByType } from "../../utils/passCode";

function PassCodeContainer({ onSubmit, loading }) {
	const { document } = usePatientDocumentContext();
	const { form } = usePatientFormContext();

	const [passCode, setPassCode] = useState('');
	const [isCpf, setIsCpf] = useState(false);
	const [passCodeTypeMessage, setPassCodeTypeMessage] = useState('');

	useEffect(() => {
		if (!document && !form) {
			return;
		}

		const passCodeType = document?.type || form?.type || 'CPF';
		const isCpf = passCodeType === 'CPF';

		setIsCpf(isCpf);
		setPassCode(passCode)
		setPassCodeTypeMessage(passCodeMessageByType[passCodeType]);
	}, [document, form, passCode]);

	const handleSubmit = useCallback((passCode) => {
		setPassCode(passCode)

		const sanitezedPassCode = passCode.replace(/[^A-Za-z0-9]/g, '');

		onSubmit(isCpf ? sanitezedPassCode : passCode);
	}, [onSubmit, isCpf]);

	return (
		<PassCode
			loading={loading}
			passCodeTypeMessage={passCodeTypeMessage}
			isCpf={isCpf}
			submit={handleSubmit}
		/>
	);
}

export default PassCodeContainer;
